
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import Dator from "@/utils/censor.js";
import loginFun from "@/utils/cc-webapp/login.js";

export default {
name: "bindEmail",
components: {
XInput,
Group,
Picker,
Popup
},
mounted: function() {

},
data() {
return {
iconNone: require("@/assets/image/icon/dele.png"),
iconAll: {
iconLogo: require("@/assets/image/icon/logo.png"),
wechatLogo: require("@/assets/image/icon/wechat_logo.png"),
facebookLogo: require("@/assets/image/icon/facebook_logo.png"),
googleLogo: require("@/assets/image/icon/google_logo.png")
},
formD: {
email: "",
password: "",
passwordConfirm: "",
code: ""
},
isLogin: false,
isGetPage: false,
second:0
};
},
methods: {

onClickLeft(){
this.$router.go(-1)
},

sendEmailCode() {
let dator = new Dator.dator();
dator.add(this.formD.email, [
{ strategy: "isEmpty", errMsg: this.$t('FORGET_LANG.emailNullErr') },
{ strategy: "checkEmail", errMsg: this.$t('FORGET_LANG.emailErr') }
]);

if (dator.getErrmsg()) {
native.showToast(dator.getErrmsg());
return;
}

let postD = {
email: this.formD.email
};
this.GLOBAL_.ccRequest
.doAxios(this.CONFIG.USER.EMAILVERIFICATIONCODE, postD, "POST")
.then(res => {

this.second = 60;
this.startCounting();
this.$toast.text(this.$t('FORGET_LANG.sendCode') );
})
.catch(err => {

let res = err.response;
this.$toast.text(this.$t('FORGET_LANG.getCodeErr')+"：" + res.data.message);
});
},


startCounting() {
let _this = this;


if (this.second > 0) {
this.countor = setInterval(() => {
_this.second -= 1;
if (_this.second === 0) {
clearInterval(_this.countor);
}
}, 1000);
} else {
clearInterval(_this.countor);
}
},

doBindEmail() {


let dator = new Dator.dator();
dator.add(this.formD.email, [
{ strategy: "isEmpty", errMsg: this.$t('FORGET_LANG.emailNullErr') },
{ strategy: "checkEmail", errMsg:this.$t('FORGET_LANG.emailErr')}
]);

dator.add(this.formD.code, [
{ strategy: "isEmpty", errMsg: this.$t('FORGET_LANG.inputCode')  },
{ strategy: "checkStringFormat:4:1", errMsg: this.$t('FORGET_LANG.CodeErr') }
]);

dator.add(this.formD.password, [
{ strategy: "isEmpty", errMsg: this.$t('FORGET_LANG.inputPassThree')},
{ strategy: "checkPassworld", errMsg: this.$t('FORGET_LANG.passMessage') }
]);

dator.add(this.formD.passwordConfirm, [
{ strategy: "isEmpty", errMsg: this.$t('FORGET_LANG.inputPassFour')},
{ strategy: "checkPassworld", errMsg: this.$t('FORGET_LANG.passMessage') }
]);

dator.add(this.formD.passwordConfirm, [
{
strategy: "checkEqual:" + this.formD.password,
errMsg:this.$t('FORGET_LANG.twoPassErr')
}
]);

if (dator.getErrmsg()) {
this.$toast.text(dator.getErrmsg());
return;
}

this.$toast.loading();


let postD = {
email: this.formD.email,
password: this.formD.password,
code:this.formD.code
};
this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.USER.BINDEMAIL, postD, "POST", false, this.$route.query.session)
.then(res => {
console.log('bindSuccess', res)
this.$toast.close();
this.$toast.text(this.$t('BINDEMAIL_LENG.bindSuccess'));

if (this.isGetPage) {

let obj = this.session;
obj["userInfo"] = this.userInfo;
loginFun.saveLoginSession(obj);

setTimeout(() => {
this.$toast.close();
this.$router.push({ path: '/my'})
}, 500);
} else {


setTimeout(() => {
this.$toast.close();
this.$router.back()
}, 500);
}
})
.catch(err => {
this.$toast.close();
let res = err.response;
this.$toast.text(this.$t('BINDEMAIL_LENG.bindFail')+"：" + res.data.message);
});
}
},
mounted: function() {
let getPage = this.$route.query.getPage;
if (getPage) {
this.isGetPage = true;
}
this.LOGIN2.getSession("no login")
.then(session => {
console.log("session", session);

this.isGetPage = false;
})
.catch(err => {
console.log("沒有session", err);
this.session = this.$route.query.session;
this.userInfo = this.$route.query.userInfo;
});

},
created() {}
};



// WEBPACK FOOTER //
// ./src/pages/me/bindEmail.vue